import { Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

import { SnackbarService } from '../../../services/snackbar.service';
import { ApiLotsDialogService } from '../../../services/api/api-lots-dialog.service';
import { ContractUtils } from '../../utils/contract.util';
import { IContractsInLot, ILot, DetailLotEnum } from '../../../models/generic';
import { LotsGroupDialogComponent } from './lots-group-dialog/lots-group-dialog.component';
import { ListContractsDialogComponent } from './list-contracts-dialog/list-contracts-dialog.component';
import { TabTypeEnum, IContractLot } from 'src/app/models/generic';
import {
  DialogContractTypeEnum,
  DialogTypeEnum,
  IDialogConfirm,
  IManagementContractsModalData
} from 'src/app/models/dialog';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ITab } from 'src/app/models/tabs';

@Component({
  selector: 'app-dialog-contracts',
  templateUrl: './dialog-contracts.component.html',
  styleUrls: ['./dialog-contracts.component.scss']
})
export class DialogContractsComponent implements OnInit, OnDestroy {
  DialogTypeEnum = DialogContractTypeEnum;
  TabTypeEnum = TabTypeEnum;
  dialogType = this.data?.type;
  typeLot: DetailLotEnum = this.data.template.typeLot!;

  lotActive?: ILot = this.data?.lot;
  lotsDetailList: Array<ILot> = [];
  contractsInLots?: Array<IContractLot> = this.data?.contractsInLots;
  lotsList: Array<ILot> = [];
  tabs: ITab[] = [];
  actionTab: number | string = 1;
  disableGenerateLots: boolean = false;
  firstElement: number = 0;

  // Listas para contratos excluídos e cancelados
  excludedContracts: Array<string> = [];
  cancelledContracts: Array<string> = [];

  originalContractIds: Array<string> = [];

  // Subscriptions para observables
  private excludedSubscription?: Subscription;
  private cancelledSubscription?: Subscription;

  searchField = new FormControl<string>('', { nonNullable: true });

  @ViewChild('listContract')
  listContractComponent?: ListContractsDialogComponent;

  @ViewChild('lotsGroup')
  lotsGroupComponent?: LotsGroupDialogComponent;

  constructor(
    private _dialogService: ApiDialogService,
    private _lotsService: ApiLotsDialogService,
    public dialogRef: MatDialogRef<DialogContractsComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IManagementContractsModalData,
    private router: Router,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    // Armazenar os ids dos contratos originais do lote
    this.originalContractIds =
      this.lotActive?.Contracts?.map((contract) => contract.ContractId) || [];

    // Inscreve nos observables dos contratos
    // Apenas se o tipo de diálogo permitir exclusões ou cancelamentos
    if (this.dialogType === DialogTypeEnum.Confirmation) {
      this.excludedSubscription = ContractUtils.excludedContracts$.subscribe(
        (excluded) => {
          this.excludedContracts = excluded;
        }
      );

      this.cancelledSubscription = ContractUtils.cancelledContracts$.subscribe(
        (cancelled) => {
          this.cancelledContracts = cancelled;
        }
      );
    }

    switch (this.dialogType) {
      case this.DialogTypeEnum.EditContract:
        this.transformLotGroups();
        break;

      case this.DialogTypeEnum.ViewContract:
        this.generateTabs();
        this.builderLotsWithContracts();
        break;
    }
  }

  ngOnDestroy(): void {
    //Desinscrevendo as subscriptions da instância certa do componente
    if (this.dialogType === DialogTypeEnum.Confirmation) {
      if (this.excludedSubscription) {
        this.excludedSubscription.unsubscribe();
      }
      if (this.cancelledSubscription) {
        this.cancelledSubscription.unsubscribe();
      }

      // Limpa o estado dos contratos
      ContractUtils.reset();
    }
  }

  transformLotGroups(): void {
    console.log(this.lotActive);
    const newFirstLot: ILot = {
      AmountTotal: 0,
      Bank: '',
      Channel: '',
      CreateDate: '',
      BatchId: 1,
      BatchNumber: '',
      BatchStatus: '',
      NumberOfContracts: this.lotActive?.Contracts?.length ?? 0,
      Partner: '',
      Checked: false,
      Contracts: [...(this.lotActive?.Contracts ?? [])]
    };

    this.lotsList.push(newFirstLot);
  }

  submitModal(): void {
    switch (this.dialogType) {
      case this.DialogTypeEnum.EditContract:
        this.openGenerateLotsDialog();
        break;

      case this.DialogTypeEnum.ViewContract:
        this.typeLot == DetailLotEnum.Transfer
          ? this.builderGenerateTransferLots()
          : this.builderGenerateInvoiceLots();
        break;

      case this.DialogTypeEnum.AddContract:
        this.addContractList();
        break;
    }
  }

  addContractList(): void {
    this.dialogRef.close(this.listContractComponent?.contractsCheck);
  }

  handleSearchField(): void {
    const searchFieldFormat = this.searchField.value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    this._dialogService.searchFieldEvent.next(searchFieldFormat);
  }

  openGenerateLotsDialog(): void {
    const dataDialog: IManagementContractsModalData = {
      type: DialogContractTypeEnum.ViewContract,
      newLots: this.lotsList,
      lot: this.lotActive,
      template: {
        title: 'Confira as informações e os contratos',
        textConfirmButton: 'Atualizar lote',
        typeLot: this.typeLot
      }
    };

    if (this.lotsList?.[this.firstElement]?.Contracts?.length === 0) {
      this.openBatchCancel(this.lotActive?.BatchNumber.toString() ?? '');
    } else {
      this._dialogService
        .openDialogContracts(dataDialog)
        .then((response) => {});
    }
  }

  openBatchCancel(batchNumber: string): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Cancelar lote',
        title: 'Se confirmar, o lote será cancelado. Deseja continuar?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        switch (this.typeLot) {
          case DetailLotEnum.Transfer:
            break;
          case DetailLotEnum.Invoicing:
            this.deleteBatch(batchNumber);
            break;
        }
      }
    });
  }

  deleteBatch(batchNumber: string): void {
    const cancelledFromUtil = ContractUtils.getCancelledContracts();
    const contractsInLot: IContractsInLot = {
      BatchNumber: batchNumber,
      ContractsIds: [],
      ContractsCancelledIds: cancelledFromUtil
    };

    this._lotsService.getDetailsNewLotInvoicing(contractsInLot).subscribe({
      next: (response) => {
        this.snackbarService.openSnackBar(
          'Lote cancelado com sucesso!',
          'success'
        );
        this.dialog.closeAll();
        this.router.navigate(['/faturamento-contratos']);
      }
    });
  }

  generateTabs(): void {
    this.tabs = this.data.newLots?.map((lot, index) => {
      return {
        title: `Novo Lote`,
        id: index + 1
      };
    }) as ITab[];
  }

  builderLotsWithContracts(): void {
    const newLot: ILot | null = this.data.newLots ? this.data.newLots[0] : null;

    const contractsInLot: IContractsInLot = {
      BatchNumber: this.lotActive?.BatchNumber.toString()!,
      ContractsIds: newLot?.Contracts?.map((contract) => contract.ContractId)
    };

    this.getDetailsLotAPI(contractsInLot);
  }

  getDetailsLotAPI(contractsInLot: IContractsInLot): void {
    switch (this.typeLot) {
      case DetailLotEnum.Transfer:
        this.getLotDetailsTransfers(contractsInLot);
        this.typeLot = DetailLotEnum.Transfer;
        break;

      case DetailLotEnum.Invoicing:
        this.getLotDetailsInvoincing(contractsInLot);
        this.typeLot = DetailLotEnum.Invoicing;
        break;
    }
  }

  getLotDetailsInvoincing(contractsInLot: IContractsInLot): void {
    this._lotsService.getDetailsNewLotInvoicing(contractsInLot).subscribe({
      next: (response) => {
        if (response.Data) this.lotsDetailList.push(response.Data);

        if (response?.Data?.AmountTotal <= 0) {
          this.disableGenerateLots = true;
          this.snackbarService.openSnackBar(
            'Valor Total de Comissão deve ser válido!',
            'warning',
            4000
          );
        }
      },
      error: (err) => {
        this.disableGenerateLots = true;
      }
    });
  }

  getLotDetailsTransfers(contractsInLot: IContractsInLot): void {
    this._lotsService.getDetailsNewLotTransfer(contractsInLot).subscribe({
      next: (response) => {
        if (response.Data) this.lotsDetailList.push(response.Data);
      }
    });
  }

  handleAmountInvoicing(contracts: IContractLot[]): boolean {
    let totalValueFinancing = 0;

    contracts.forEach((contract) => {
      if (
        contract.Status.toLowerCase() === 'a estornar' ||
        contract.Status.toLowerCase() === 'estornar' ||
        contract.Status.toLowerCase() === 'estornado parcial'
      ) {
        totalValueFinancing -= contract?.Amount ?? 0;
      } else {
        totalValueFinancing += contract?.Amount ?? 0;
      }
    });

    return totalValueFinancing > 0;
  }

  builderGenerateTransferLots(): void {
    const contractsExcludes: Array<string> = this.checkContractsExcludes();

    const contractsInLots: Array<IContractsInLot> = this.lotsDetailList.map(
      (lot) => {
        return {
          BatchNumber: this.lotActive?.BatchNumber.toString(),
          ContractsInsertsIds: this.checkContractsIncludes(lot.Contracts!),
          ContractsExcludesIds: contractsExcludes
        } as IContractsInLot;
      }
    );

    this.generateLots(contractsInLots);
  }

  builderGenerateInvoiceLots(): void {
    const excludedFromUtil = ContractUtils.getExcludedContracts();
    const cancelledFromUtil = ContractUtils.getCancelledContracts();

    const contractsInLots: Array<IContractsInLot> = this.lotsDetailList.map(
      (lot) => {
        return {
          BatchNumber: this.lotActive?.BatchNumber.toString(),
          ContractsInsertsIds: this.checkContractsIncludes(lot.Contracts!),
          ContractsExcludesIds: excludedFromUtil,
          ContractsCancelledIds: cancelledFromUtil
        } as IContractsInLot;
      }
    );

    this.generateLots(contractsInLots);
  }

  checkContractsIncludes(contracts: IContractLot[]): Array<string> {
    let contractNumberList: Array<string> = [];

    contracts.forEach((contract) => {
      let contractIndex: number = this.lotActive?.Contracts?.findIndex(
        (findContract) => findContract.ContractId === contract.ContractId
      )!;

      if (contractIndex === -1) contractNumberList.push(contract.ContractId!);
    });

    return contractNumberList;
  }

  checkContractsExcludes(): Array<string> {
    let contracts: Array<string> = [];

    this.lotsDetailList.forEach((lot) => {
      for (const contract of this.lotActive?.Contracts!) {
        let index: number = lot.Contracts?.findIndex(
          (lotContract) => lotContract.ContractId === contract.ContractId
        )!;

        if (index === -1) contracts.push(contract.ContractId!);
      }
    });

    return contracts;
  }

  generateLots(contractsInLots: Array<IContractsInLot>): void {
    let dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Gerar novo lote',
        title: 'Como foi alterado, será gerado um novo lote. Tem certeza que deseja confirmar?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    if (
      this.lotActive != null &&
      this.lotActive != undefined &&
      this.lotActive.BatchStatus == 'Em Andamento'
    ) {
      dialogData = {
        type: DialogTypeEnum.Optional,
        appearance: 'modern',
        template: {
          boldTitle: 'Confirmar alteração do lote',
          title: 'O lote será alterado, tem certeza que deseja confirmar?',
          confirm: 'Sim',
          dismiss: 'Não'
        }
      };
    }

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        switch (this.typeLot) {
          //case DetailLotEnum.Transfer:
          //  this.generateLotTransfers(contractsInLots);
          //  this.data.template.typeLot = DetailLotEnum.Transfer;
          //  break;
          case DetailLotEnum.Invoicing:
            this.generateLotInvoicing(contractsInLots);
            this.data.template.typeLot = DetailLotEnum.Invoicing;
            break;
        }
      }
    });
  }

  generateLotInvoicing(contractsInLots: Array<IContractsInLot>): void {
    this._lotsService.generateLotInvoicing(contractsInLots).subscribe({
      next: (response) => {
        if (response.ReturnCode === 0) {
          this.snackbarService.openSnackBar(
            'Lote atualizado com sucesso!',
            'success'
          );
          this.dialog.closeAll();
          this.router.navigate(['/faturamento-contratos']);
        }
      }
    });

    this.dialog.closeAll();
  }

  //generateLotTransfers(contractsInLots: Array<IContractsInLot>): void {
  //  this._lotsService.generateLotsTransfer(contractsInLots).subscribe({
  //    next: (response) => {
  //      if (response.ReturnCode === 0) {
  //        this.snackbarService.openSnackBar(
  //          'Lote gerado com sucesso!',
  //          'success'
  //        );
  //        this.dialog.closeAll();
  //        this.router.navigate(['/repasse-comissao']);
  //      }
  //    }
  //  });

  //  this.dialog.closeAll();
  //}

  changeTabs(tab: number | string): void {
    this.actionTab = tab;
  }

  /**
   * Verifica se um contrato é original do lote (não foi adicionado dinamicamente)
   */
  isOriginalContract(contractId: string): boolean {
    return this.originalContractIds.includes(contractId);
  }
}
